import { render, staticRenderFns } from "./login_profile.vue?vue&type=template&id=66ff0d72&scoped=true"
import script from "./login_profile.vue?vue&type=script&lang=js"
export * from "./login_profile.vue?vue&type=script&lang=js"
import style0 from "./login_profile.vue?vue&type=style&index=0&id=66ff0d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff0d72",
  null
  
)

export default component.exports